import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ApartmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"apartment"}/>
}
